import React from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import './help-tooltip.scss';

const HelpTooltip = ({
	title = 'Title',
	content = (
		<div>
			<p>Content will be displayed here</p>
		</div>
	),
	...rest
}) => {
	return (
		<Popover placement="right" title={title} content={content}>
			<QuestionCircleOutlined className="commission_icon" {...rest} />
		</Popover>
	);
};

export default HelpTooltip;
